import React, { useState } from "react";

const puzzles = [
    {
        grid: [
            [1, null, 3],
            [null, 2, null],
            [3, null, 1]
        ],
        solution: [
            [1, 2, 3],
            [3, 2, 1],
            [3, 1, 1]
        ],
        hint: "Ogni riga deve sommare a 6"
    },
    {
        grid: [
            [null, 4, null],
            [2, null, 3],
            [null, 1, null]
        ],
        solution: [
            [3, 4, 2],
            [2, 5, 3],
            [4, 1, 2]
        ],
        hint: "Numeri da 1 a 5"
    },
    {
        grid: [
            [5, null, null],
            [null, 3, null],
            [null, null, 1]
        ],
        solution: [
            [5, 2, 4],
            [4, 3, 2],
            [3, 4, 1]
        ],
        hint: "Diagonale crescente"
    }
];

export default function LogicGrid() {
    const [currentPuzzle, setCurrentPuzzle] = useState(0);
    const [grid, setGrid] = useState(JSON.parse(JSON.stringify(puzzles[0].grid)));
    const [completed, setCompleted] = useState(false);
    const [started, setStarted] = useState(false);
    const [attempts, setAttempts] = useState(0);
    const [score, setScore] = useState(0);

    const startGame = () => {
        setStarted(true);
        setCurrentPuzzle(0);
        setGrid(JSON.parse(JSON.stringify(puzzles[0].grid)));
        setCompleted(false);
        setAttempts(0);
        setScore(0);
    };

    const handleCellChange = (row, col, value) => {
        const newGrid = [...grid];
        newGrid[row][col] = value === "" ? null : parseInt(value);
        setGrid(newGrid);
    };

    const checkSolution = () => {
        const puzzle = puzzles[currentPuzzle];
        let isCorrect = true;

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 3; j++) {
                if (grid[i][j] !== puzzle.solution[i][j]) {
                    isCorrect = false;
                    break;
                }
            }
            if (!isCorrect) break;
        }

        if (isCorrect) {
            setScore(score + 1);
            if (currentPuzzle + 1 < puzzles.length) {
                setTimeout(() => {
                    setCurrentPuzzle(currentPuzzle + 1);
                    setGrid(JSON.parse(JSON.stringify(puzzles[currentPuzzle + 1].grid)));
                }, 1000);
            } else {
                setCompleted(true);
            }
        } else {
            setAttempts(attempts + 1);
        }
    };

    const skipPuzzle = () => {
        if (currentPuzzle + 1 < puzzles.length) {
            setCurrentPuzzle(currentPuzzle + 1);
            setGrid(JSON.parse(JSON.stringify(puzzles[currentPuzzle + 1].grid)));
        } else {
            setCompleted(true);
        }
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-th" style={{marginRight:"6px"}}></i> Logic Grid
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>
                    Completa la griglia seguendo le regole logiche!
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (completed) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score}/{puzzles.length} puzzle risolti
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === puzzles.length && "🎉 Perfetto! Logica impeccabile!"}
                    {score === 2 && "👍 Ottimo! Due su tre!"}
                    {score === 1 && "💪 Buon inizio!"}
                    {score === 0 && "🧩 Riprova, serve logica!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Puzzle {currentPuzzle + 1} di {puzzles.length} - Punteggio: {score}
            </div>

            <div style={{
                padding:"0.6rem",
                background:"rgba(59,130,246,0.1)",
                borderRadius:"0.5rem",
                marginBottom:"1rem",
                fontSize:"0.8rem",
                color:"#94a3b8"
            }}>
                <i className="fas fa-lightbulb" style={{marginRight:"6px", color:"#facc15"}}></i>
                {puzzles[currentPuzzle].hint}
            </div>

            <div style={{
                display:"grid",
                gridTemplateColumns:"repeat(3, 1fr)",
                gap:"0.5rem",
                marginBottom:"1.5rem",
                maxWidth:"200px",
                margin:"0 auto 1.5rem"
            }}>
                {grid.map((row, i) =>
                    row.map((cell, j) => (
                        <input
                            key={`${i}-${j}`}
                            type="number"
                            min="1"
                            max="5"
                            value={cell === null ? "" : cell}
                            onChange={(e) => handleCellChange(i, j, e.target.value)}
                            disabled={puzzles[currentPuzzle].grid[i][j] !== null}
                            style={{
                                width:"100%",
                                aspectRatio:"1",
                                textAlign:"center",
                                fontSize:"1.2rem",
                                fontWeight:"700",
                                border: puzzles[currentPuzzle].grid[i][j] !== null
                                    ? "2px solid rgba(59,130,246,0.5)"
                                    : "2px solid rgba(255,255,255,0.2)",
                                background: puzzles[currentPuzzle].grid[i][j] !== null
                                    ? "rgba(59,130,246,0.2)"
                                    : "rgba(255,255,255,0.05)",
                                color:"#fff",
                                borderRadius:"0.5rem",
                                outline:"none"
                            }}
                        />
                    ))
                )}
            </div>

            {attempts > 0 && (
                <p style={{color:"#ef4444", fontSize:"0.85rem", marginBottom:"1rem"}}>
                    ✗ Tentativo {attempts} - Ricontrolla!
                </p>
            )}

            <div style={{display:"flex", gap:"0.5rem"}}>
                <button
                    onClick={checkSolution}
                    style={{
                        flex:1,
                        background:"linear-gradient(135deg,#2563eb,#1e40af)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
                </button>
                <button
                    onClick={skipPuzzle}
                    style={{
                        background:"rgba(239,68,68,0.2)",
                        border:"1px solid rgba(239,68,68,0.3)",
                        color:"#ef4444",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-forward"></i>
                </button>
            </div>
        </div>
    );
}